import { useState } from 'react'
import PropTypes from 'prop-types'
import { List, ListItem, ListItemIcon, ListItemText, Typography, Collapse, Divider } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

// Icons
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'

const NavBarAccordionNestedItem = ({ index, title, Icon, nestedItems, isSelected, openMostRecentOnLoad }) => {

  const [openNested, setOpenNested] = useState(openMostRecentOnLoad ? index === 0 : false)

  return (
    <>
      <Divider
        sx={{
          margin: '0 16px 0 -16px'
        }}/>
      <ListItem button onClick={() => setOpenNested(!openNested)}
        sx={{
          minHeight: '44px',
          padding: '5px 0 5px 0',
          '&:hover': { backgroundColor: 'transparent' },
        }}>
        {Icon && (
          <ListItemIcon>
            <Icon />
          </ListItemIcon>
        )}
        <ListItemText
          sx={{
            fontWeight: 400,
            color: 'rgba(233,236,239,.5)',
            '&:hover': {
              color: '#ced4da',
            },
            '& span, & svg': {
              fontSize: '14px',
            }
          }}
          primary={<Typography
            sx={{
              color: '#263238',
              fontSize: '14px',
              letterSpacing: '0',
              lineHeight: '19px',
              '&:hover': { opacity: '0.8' },
            }}>
            {title}
          </Typography>}/>
        <div style={{ marginRight: 20, marginTop: 5 }}>
          {nestedItems.length > 0 && (<>
            {openNested ? <ExpandLess /> : <ExpandMore />}
          </>)}
        </div>
      </ListItem>

      <Collapse in={openNested} timeout="auto" unmountOnExit>
        <List component="div" disablePadding style={{ paddingLeft: 30 }}>
          {nestedItems.map((nestedItem, nestedIndex) => (
            <ListItem
              button
              sx={{
                minHeight: '44px',
                padding: '5px 0 5px 0',
                '&:hover': { backgroundColor: 'transparent' },
                marginLeft: -2,
                '-webkit-font-smoothing': 'antialiased',
                'transition': '.3s'
              }}
              style={{
                marginBottom: nestedItems.length - 1 === nestedIndex ? 15 : 0,
              }}
              key={`nav-bar-accordion-level-3-items-${nestedIndex}`}
              component={RouterLink}
              to={nestedItem.link}>
              {nestedItem?.Icon && ( // Icon
                <ListItemIcon>
                  <nestedItem.Icon
                    sx={{
                      ...(isSelected(nestedItem.link) && {
                        color: '#ced4da',
                        width: '18px',
                        height: '18px',
                      })
                    }}/>
                </ListItemIcon>
              )}
              <ListItemText
                sx={{
                  fontWeight: 400,
                  color: 'rgba(233,236,239,.5)',
                  '&:hover': {
                    color: '#ced4da',
                  },
                  '& span, & svg': {
                    fontSize: '14px',
                  }
                }}
                primary={<Typography
                  sx={{
                    color: '#263238',
                    fontSize: '14px',
                    letterSpacing: '0',
                    lineHeight: '19px',
                    '&:hover': { opacity: '0.8' },
                    ...( isSelected(nestedItem.link) && {
                      color: '#4D4F53',
                      textDecoration: 'underline',
                      textDecorationThickness: '2px',
                      textDecorationColor: '#4D4F53',
                      textUnderlinePosition: 'under',
                    })
                  }}>
                  {nestedItem.title}
                </Typography>}/>
            </ListItem>
          ))}
        </List>
      </Collapse>
    </>
  )
}

NavBarAccordionNestedItem.propTypes = {
  index: PropTypes.number,
  title: PropTypes.string,
  Icon: PropTypes.array,
  nestedItems: PropTypes.array,
  isSelected: PropTypes.func,
  openMostRecentOnLoad: PropTypes.bool,
}

export default NavBarAccordionNestedItem
